import React, { useEffect, useRef, useState } from "react";
import { ConversationMode, InterViewCurrentTask } from "../../types/interview.type";
import { useInterview } from "../../contexts/interview.context";
import { toast } from "react-toastify";
import { useTheme } from "../../context";
import { IoSend } from "react-icons/io5";
import { SessionStorage } from "../../types/general.type";

const MessageInput = () => {
  const { theme } = useTheme();
  const { interview, updateInterview, sendMessage: onSendMessage, finalTranscript, setFinalTranscript } = useInterview();
  const {
    isChatInputsEnabled,
    isEnabledSubmitButton,
    setUp,
    isOnline
  } = interview;

  const inputRef = useRef<HTMLTextAreaElement | null>(null);
  useEffect(() => {

    const isChatMode = setUp?.conversationMode === ConversationMode.CHAT

    const listening = !!sessionStorage.getItem(SessionStorage.LISTENING)
    // Check if audio has started and is currently playing
    if (!listening && !isChatMode) {

      setFinalTranscript("");
      return;
    }

    if (finalTranscript) {
      updateInterview({
        isEnabledSubmitButton: true,
      });
    }
  }, [finalTranscript, updateInterview]);



  const sendMessage = async () => {
    if (!isOnline) {

      return;
    }
    const trimmedInput = finalTranscript.trim();
    if (trimmedInput !== "") {
      setFinalTranscript("");
      if (inputRef.current)
        inputRef.current.style.height = '50px'
      await onSendMessage(trimmedInput);
    } else {
      toast.info("No input to send");
    }
  };

  const autoResizeTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = e.target;
    textarea.style.height = "auto"; // reset height
    textarea.style.height = "50px";
    textarea.style.height = `${textarea.scrollHeight}px`; // set to scrollHeight
  };


  return (
    <>
      <style>
        {`
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: ${theme === "dark" ? "rgba(46,45,50,1)" : "rgba(247,248,250,1)"};
            border-radius: 3px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: ${theme === "dark" ? "rgba(59,130,246,0.7)" : "rgba(59,130,246,0.5)"};
            border-radius: 3px;
            transition: background-color 0.2s;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: ${theme === "dark" ? "rgba(59,130,246,0.9)" : "rgba(59,130,246,0.7)"};
          }
          /* Firefox */
          .custom-scrollbar {
            scrollbar-width: thin;
            scrollbar-color: ${theme === "dark"
            ? "rgba(59,130,246,0.7) rgba(46,45,50,1)"
            : "rgba(59,130,246,0.5) rgba(247,248,250,1)"
          };
          }
        `}
      </style>
      <div
        className={`flex  flex-row items-center h-fit gap-2 w-full max-w-full border rounded-lg px-2 py-1 md:px-4 lg:py-2 transition-all duration-200
        ${theme === "dark"
            ? "bg-[rgba(46,45,50,1)] border-accent-700/40"
            : "bg-[rgba(247,248,250,1)] border-accent-700/40"
          }
        shadow-md dark:shadow-lg`
        }
      >
        <textarea
          ref={inputRef}
          className={`flex-grow  outline-none px-3 py-1 md:py-2  text-sm rounded-lg overflow-auto custom-scrollbar 
          ${theme === "dark"
              ? "bg-[rgba(40,39,44,1)] text-gray-100 placeholder-gray-400 border-accent-700/40 border"
              : "bg-white text-gray-900 placeholder-gray-500 border-accent-700/40 border"
            }
          shadow-sm dark:shadow-md`
          }
          placeholder={
            isChatInputsEnabled
              ? "Type a message..."
              : !setUp?.started
                ? "Interview not started yet"
                : "Wait for interviewe response"
          }
          value={finalTranscript}
          readOnly={!isChatInputsEnabled || !setUp?.started}
          onChange={(e) => {
            setFinalTranscript(e.target.value);
            updateInterview({ currentTask: InterViewCurrentTask.YOU_TYPING });
            autoResizeTextarea(e);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey && (!!finalTranscript)) {
              e.preventDefault();
              sendMessage();
            }
          }}
          rows={1}
          style={{
            height: "50px",
            alignSelf: "center",
            maxHeight: "60px", // set the maximum height you want
            overflowY: "auto",
          }}
        />

        <button
          onClick={sendMessage}
          disabled={!isEnabledSubmitButton || !finalTranscript || !setUp?.started}
          className={`p-3.5  rounded-lg text-white transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed
      ${theme === "dark"
              ? "bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 border-accent-500 border"
              : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 border border-[rgba(59,130,246,0.2)]"
            }
      shadow-sm hover:shadow-md`}
        >
          <IoSend className="text-lg borde border-transparent" />
        </button>
      </div>

    </>
  );
};

export default MessageInput;